<template>
  <component :is="vehicleIcon" />
</template>

<script>

/**
 * Vue: Garage icon (garage-icon)
 * -----------------------------------------------------------------------------
 * Renders icon for current vehicle type.
 *
 * @param {String} type - Vehicle type.
 *
 */
import IconAtv from '~icons/general/atv.svg'
import IconBin from '~icons/general/bin.svg'
import IconCar from '~icons/general/car.svg'
import IconChainsaw from '~icons/general/chainsaw.svg'
import IconMarine from '~icons/general/marine.svg'
import IconMower from '~icons/general/mower.svg'
import IconMotorcycles from '~icons/general/motorcycles.svg'
import IconOtherVehicle from '~icons/general/other-vehicle.svg'
import IconSnowmobile from '~icons/general/snowmobile.svg'
import IconTractor from '~icons/general/tractor.svg'

export default {
  name: 'GarageIcon',

  components: {
    IconAtv,
    IconBin,
    IconCar,
    IconChainsaw,
    IconMarine,
    IconMotorcycles,
    IconMower,
    IconOtherVehicle,
    IconSnowmobile,
    IconTractor,
  },

  props: {
    type: {
      type: String,
      default: '',
      required: true,
    },
  },

  computed: {

    /**
     * Compute vehicle icon.
     * @returns {String}
     */
    vehicleIcon() {
      if (!this.type) {
        return 'icon-car'
      }

      const vehicleType = this.type.toLowerCase()

      if (vehicleType === 'other') {
        return 'icon-other-vehicle'
      }

      return `icon-${vehicleType}`
    },
  },
}
</script>
